import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';

export interface DisclosureFormReorderPatchOptions {
  position: number;
}

export function disclosureFormReorderApi(path: string) {
  return {
    path,
    PATCH: (params: DisclosureFormReorderPatchOptions) =>
      api.patch<JsonApiResponse>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(params),
          },
        })
      ),
  };
}
